import { styled } from '@mui/material';
import { MobilePaddingLessContentWrapper } from '../../../styles/shared';

export const StyledContentWrapper = styled(MobilePaddingLessContentWrapper)(
  ({ theme }) => ({
    marginBottom: theme.spacings.unit(12),
  })
);
